import { FC } from "react";
import StarFillIcon from "@src/lib/icons/18px/star-fill";
import StarOutlineIcon from "@src/lib/icons/18px/star-outline";

type Props = {
  rating: number;
  size?: number;
};

const RatingStars: FC<Props> = ({ rating, size = 24 }) => {
  return (
    <div className="grid">
      <div className="col-start-1 row-start-1 flex">
        {[1, 2, 3, 4, 5].map((num) => (
          <StarOutlineIcon
            key={num}
            className="text-yellow-4"
            style={{ width: size, height: size }}
          />
        ))}
      </div>
      <div className="col-start-1 row-start-1 flex">
        {[1, 2, 3, 4, 5].map((num) => {
          const hasFill = Math.ceil(rating) >= num;
          if (!hasFill) return null;

          const containerWidth = size * Math.min(rating + 1 - num, 1);

          return (
            <div
              key={num}
              className="overflow-hidden"
              style={{ width: containerWidth }}
            >
              <StarFillIcon
                className="text-yellow-9"
                style={{ width: size, height: size }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingStars;
